import React, { useState, useEffect } from 'react';
import ClientCrudService from '../../services/ClientCrudService';
import ProviderTypeService from '../../services/ProviderTypeService';
import dateFormat from 'dateformat';

import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion } from 'react-bootstrap';
import Spinner from '../utils/Spinner';
import InputText from '../../components/Forms/InputText'
import TabClientIdentyti from './TabClientIdentyti';

export default function ModalClient({ show, handleClose, dataItem, setRenderRows }) {

  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
  const providerTypeOptions = ProviderTypeService.getAllProviders();

  const [getAllPlans, setGetAllPlans] = useState([]);
  const [suscriptionsPlans, setSuscriptionsPlans] = useState([]);
  const [periodPrice, setPeriodPrice] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [userName, setUserName] = useState(null);
  const [userUserName, setUserUserName] = useState(null);
  const [priorityLevel, setPriorityLevel] = useState(0);
  const [userPath, setUserPath] = useState(null);
  const [providerType, setProviderType] = useState('');
  const [suscriptionCode, setSuscriptionCode] = useState('');
  const [suscriptionPeriod, setSuscriptionPeriod] = useState(-1);
  const [suscriptionExpires, setSuscriptionExpires] = useState(null);
  const [suscriptionIdT1, setSuscriptionIdT1] = useState('');
  const [t1dataShopId, setT1dataShopId] = useState(null);
  const [sellerId, setSellerId] = useState();
  const [progressConfig, setProgressConfig] = useState({});
  const [dataInfoPlan, setDataInfoPlan] = useState(null);
  const [t1SuscriptionId, sett1SuscriptionId] = useState(null);
  const [enableChangePlan, setEnableChangePlan] = useState(true);
  const [successSend, setSuccessend] = useState(null);
  const [renewedSince, setRenewedSince] = useState(null);
  const [renewedBy, setRenewedBy] = useState(null);

  const [dataService, setDataService] = useState({});
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);

  useEffect(() => {
    if (show && dataItem.codeItem > 0) {

      ClientCrudService.getAllPlans().then(async res => {
        setGetAllPlans(res.data.data);
      });

      ClientCrudService.getClientById(dataItem.codeItem).then(async res => {

        let currentClient = res.data.data[0];

        setUserName(currentClient.name);
        setUserUserName(currentClient.username);
        setUserPath(currentClient.path);
        setProviderType(currentClient.providerType);
        setSuscriptionCode(currentClient.suscription_id.planCode);
        setSuscriptionExpires(currentClient.suscription_id.expiresOn);
        setSuscriptionIdT1((currentClient.suscription_id.t1SuscriptionId == null) ? '' : currentClient.suscription_id.t1SuscriptionId);
        setT1dataShopId(currentClient.t1data.shopId);
        setProgressConfig(currentClient.progressConfig);
        setPeriodPrice("By " + currentClient.suscription_id.periodType + " $ " + currentClient.suscription_id.price);
        sett1SuscriptionId(currentClient.suscription_id.t1SuscriptionId);
        setRenewedSince(currentClient.suscription_id?.renewedOn ?? null);
        setRenewedBy(currentClient.suscription_id?.renewedBy ?? null );

        let plans = currentClient.suscription_id.plan_id.suscriptions;
        let frequency = ((!currentClient.suscription_id.frequency) ? 1 : currentClient.suscription_id.frequency);
        let periodType = currentClient.suscription_id.periodType;
        setSuscriptionsPlans(plans);
        setSuscriptionPeriod(plans.findIndex(plan => plan.frequency === frequency && plan.periodType === periodType));

        setDataService({ ...dataService, t1data: currentClient.t1data, progressConfig: currentClient.progressConfig });
        setPriorityLevel(currentClient.priorityLevel);
        setSellerId(currentClient.salesChannel?.seller_id);

      });
    } else {

      setUserName(null);
      setUserUserName(null);
      setUserPath(null);
      setProviderType('');
      setSuscriptionCode('');
      setSuscriptionExpires(null);
      setSuscriptionIdT1('');
      setT1dataShopId(null);
      setSellerId(null);
      setProgressConfig({});
      setGetAllPlans([]);
      setPeriodPrice('');
      setSuscriptionsPlans([]);
      sett1SuscriptionId(null);
      setDataInfoPlan(null);
      setSuscriptionPeriod(-1);
      setEnableChangePlan(true);
      setEnableSaveChanges(true);
      setSuccessend(null);
      setDataService({});
      setRenewedSince(null);
      setRenewedBy(null);
      setPriorityLevel(0);

    }
  }, [dataItem, show]);

  useEffect(() => {
    if (userName && dataInfoPlan === null) {

      ClientCrudService.getSuscripcionPlan(t1SuscriptionId).then(async res => {

        let currentDataInfoPlan = res.data.data;
        setDataInfoPlan(currentDataInfoPlan.suscripcion);

      });
    }
  }, [userName, dataInfoPlan, t1SuscriptionId]);

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setIsLoading(true);
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();

    } else {

      let updatePlanClient = { planCode: suscriptionCode, suscription: suscriptionPeriod, expiresOn: suscriptionExpires, t1SuscriptionId: suscriptionIdT1 };

      ClientCrudService.updatePlanClient(updatePlanClient, dataItem.codeItem).then(res => {
        sleep(1500).then(() => {
          setIsLoading(false);
          setSuccessend('success');
          handleClose();
          setRenderRows();
        });
      }).catch(err => {
        console.log(err);
        if (err.response.status !== 200) {
          setIsLoading(false);
          setSuccessend('danger');
        }
      });

    }
  };

  const handlerUpdateClient = async (event) => {
    setIsLoading(true);
    ClientCrudService.updateClient(dataService, dataItem.codeItem).then(res => {
      sleep(1500).then(() => {
        setIsLoading(false);
        setSuccessend('success');
        handleClose();
        setRenderRows();
      });
    }).catch(err => {
      console.log(err);
      if (err.response.status !== 200) {
        setIsLoading(false);
        setSuccessend('danger');
      }
    });
  };

  const formFieldsHandler = (event) => {
    switch (event.target.name) {
      case 'Name': setDataService({ ...dataService, name: event.target.value }); break;
      case 'UserName': setDataService({ ...dataService, username: event.target.value }); break;
      case 'T1data ShopId': setDataService({ ...dataService, t1data: { ...dataService.t1data, shopId: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'Path': setDataService({ ...dataService, path: event.target.value }); break;
      case 'Old Path': setDataService({ ...dataService, oldPath: event.target.value }); break;
      case 'Seller Id': setDataService({ ...dataService, salesChannel: { ...dataService.salesChannel, seller_id: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'SystemConfig': setDataService({ ...dataService, progressConfig: { ...dataService.progressConfig, systemConfig: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'Products': setDataService({ ...dataService, progressConfig: { ...dataService.progressConfig, products: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'Templates': setDataService({ ...dataService, progressConfig: { ...dataService.progressConfig, templates: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'Paymethods': setDataService({ ...dataService, progressConfig: { ...dataService.progressConfig, paymethods: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'ShippingMethods': setDataService({ ...dataService, progressConfig: { ...dataService.progressConfig, shippingMethods: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'Domain': setDataService({ ...dataService, progressConfig: { ...dataService.progressConfig, domain: event.target.value !== "" ? parseInt(event.target.value) : 0 } }); break;
      case 'Completed':
        const completedValue = event.target.value === 'true';
        setDataService({ ...dataService, progressConfig: { ...dataService.progressConfig, completed: completedValue } });
        setProgressConfig({ ...progressConfig, completed: completedValue });
        break;
      case 'ProviderType': setDataService({ ...dataService, providerType: event.target.value }); setProviderType(event.target.value); break;
      case 'PriorityLevel': setDataService({ ...dataService, priorityLevel: event.target.value !== "" ? parseInt(event.target.value) : 0 }); setPriorityLevel(event.target.value); break;

      default: break;
    }

    setEnableSaveChanges(false);
  }

  const changeSuscriptionCodeHandler = (event) => {
    setSuscriptionCode(event.target.value);
    let plan = getAllPlans.find((obj) => obj['code'] == event.target.value);
    setSuscriptionsPlans(plan.suscriptions);
    setEnableChangePlan(false);
  }

  const changePlanPeriodHandler = (event) => {

    const current = new Date();
    let indexPeriod = event.target.value;
    const freqPer = indexPeriod.split('_');

    const numPeriod = Number(parseInt(freqPer[1], 10));

    if (freqPer[0] == 'month') {
      current.setMonth((current.getMonth() + numPeriod));
    }

    if (freqPer[0] == 'year') {
      current.setMonth((current.getMonth() + (12 * numPeriod)));
    }

    setSuscriptionPeriod(freqPer[2]);
    setSuscriptionExpires(current);
    setEnableChangePlan(false);
  }

  const changeSuscriptionExpiresHandler = (event) => {
    setSuscriptionExpires(event.target.value);
    setEnableChangePlan(false);
  }

  const changeSuscriptionIdT1Handler = (event) => {
    setSuscriptionIdT1(event.target.value);
  }

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = (<><Button type="button" onClick={handleSubmit} disabled={enableChangePlan}>Change Plan</Button></>);
  }

  let addSubmitButton1 = "";
  if (!conditionView) {
    addSubmitButton1 = (<><Button type="button" disabled={enableSaveChanges} onClick={() => handlerUpdateClient()} >Save Data</Button></>);
  }

  const setCloseButton = <><Button variant="secondary" onClick={handleClose}> Close </Button></>;

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static"
				aria-labelledby="contained-modal-title-vcenter"
				dialogClassName="custom-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Tabs
            defaultActiveKey="main"
            id="justify-tab-example"
            className="mb-3"
            justify
          >
            <Tab eventKey="main" title="Data Order">

              <Row className="mb-3">
                <InputText defaultValue={userName} label={'Name'} handler={formFieldsHandler} conditionView={conditionView} width={'5'} />
                <InputText defaultValue={userUserName} label={'UserName'} handler={formFieldsHandler} conditionView={conditionView} width={'4'} />
                <InputText defaultValue={t1dataShopId} label={'T1data ShopId'} handler={formFieldsHandler} conditionView={conditionView} width={'3'} />
              </Row>

              <Row className="mb-3">
                <InputText defaultValue={userPath} label={'Path'} handler={formFieldsHandler} conditionView={conditionView} width={'5'} />
                <InputText defaultValue={userPath} label={'Old Path'} handler={formFieldsHandler} conditionView={conditionView} width={'5'} />
                <InputText defaultValue={sellerId} label={'Seller Id'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
              </Row>

              <Row className="mb-3">
              <Form.Group as={Col} md="3" key={2}>
                  <Form.Label>PriorityLevel</Form.Label>
                  <Form.Select
                    name="PriorityLevel"
                    onChange={conditionView ? null : formFieldsHandler}
                    readOnly={conditionView ? true : false}
                    disabled={conditionView ? true : false}
                    value={priorityLevel}
                  >
                    <option key='0' value='0' >Baja</option>
                    <option key='1' value='1' >Media</option>
                    <option key='2' value='2' >Alta</option>
                    <option key='3' value='3' >Muy Alta</option>
                  </Form.Select>
                </Form.Group>
                <InputText defaultValue={progressConfig.systemConfig} label={'SystemConfig'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
                <InputText defaultValue={progressConfig.products} label={'Products'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
                <InputText defaultValue={progressConfig.templates} label={'Templates'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
                <InputText defaultValue={progressConfig.paymethods} label={'Paymethods'} handler={formFieldsHandler} conditionView={conditionView} width={'2'} />
              </Row>

              <Row className="mb-3">
                <InputText defaultValue={progressConfig.shippingMethods} label={'ShippingMethods'} handler={formFieldsHandler} conditionView={conditionView} width={'3'} />
                <InputText defaultValue={progressConfig.domain} label={'Domain'} handler={formFieldsHandler} conditionView={conditionView} width={'3'} />

                <Form.Group as={Col} md="3" key={1}>
                  <Form.Label>Completed</Form.Label>
                  <Form.Select
                    name="Completed"
                    onChange={conditionView ? null : formFieldsHandler}
                    readOnly={conditionView ? true : false}
                    disabled={conditionView ? true : false}
                    value={progressConfig.completed}
                  >
                    <option key='false' value='false' >False</option>
                    <option key='true' value='true' >True</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group as={Col} md="3" key={2}>
                  <Form.Label>ProviderType</Form.Label>
                  <Form.Select
                    name="ProviderType"
                    onChange={conditionView ? null : formFieldsHandler}
                    readOnly={conditionView ? true : false}
                    disabled={conditionView ? true : false}
                    value={providerType}
                  >

                    {providerTypeOptions.map((itemRole) => {
                        return (<option key={itemRole} value={itemRole}>{itemRole}</option>)
                      })}

                  </Form.Select>
                </Form.Group>

              </Row>
              {isLoading ? <Spinner /> : null}
              <br />
              {addSubmitButton1}
              {'  '}  {'  '}
              {setCloseButton}
              <br />
              {(successSend == 'danger') ? (<Alert key='danger' variant='danger'> ¡Not Update, Try later!</Alert>)
                : (successSend == 'success') ? (<Alert key='success' variant='success'> ¡Send Update Success!</Alert>) : ""}
            </Tab>

            <Tab eventKey="changeplan" title="Plan">
              <Form>
                <Row className="mb-3">
                  <Accordion>

                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Suscripcion Plan</Accordion.Header>
                      <Accordion.Body>
                        <pre style={{ maxHeight: '45vh', overflowY: 'auto', marginBottom: '20px' }}>
                          {JSON.stringify(dataInfoPlan, null, 2)}
                        </pre>
                      </Accordion.Body>
                    </Accordion.Item>

                  </Accordion>
                </Row>

                <Row className="mb-2">

                  <Form.Group as={Col} md="3" key={1}>
                    <Form.Label>Suscription PLAN</Form.Label>
                    <Form.Select
                      required="Plan Type is required"
                      onChange={conditionView ? null : changeSuscriptionCodeHandler}
                      readOnly={conditionView ? true : false}
                      disabled={conditionView ? true : false}
                      value={suscriptionCode}
                    >

                      {getAllPlans.map((itemRole) => {
                        return (<option key={itemRole.code} value={itemRole.code}>{itemRole.name}</option>)
                      })}
                      <option key='gratis' value='Plan de prueba 30 dias gratis' >Plan de prueba 30 dias gratis</option>

                    </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} md="3" key={2}>
                    <Form.Label>Period PLAN </Form.Label>
                    <Form.Select
                      required="Period is required"
                      onChange={conditionView ? null : changePlanPeriodHandler}
                      readOnly={conditionView ? true : false}
                      disabled={conditionView ? true : false}
                    >
                      <option>{periodPrice}</option>
                      {suscriptionsPlans.map((itemRole, index) => {
                        return (<option key={itemRole.price} value={(itemRole.periodType + '_' + itemRole.frequency + '_' + index)}> By {itemRole.frequency + ' ' + itemRole.periodType + ' Price $' + itemRole.price}</option>)
                      })}

                    </Form.Select>
                  </Form.Group>

                  <Form.Group as={Col} md="3" key={3}>
                    <Form.Label>Suscription Expires</Form.Label>
                    <Form.Control
                      required
                      type="date"
                      placeholder="Suscription Expire"
                      value={(dateFormat(suscriptionExpires, "yyyy-mm-dd", true))}
                      onChange={conditionView ? null : changeSuscriptionExpiresHandler}
                      readOnly={conditionView ? true : false}
                      disabled={conditionView ? true : false}
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="3" key={4}>
                    <Form.Label>Suscription id T1</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Suscription Id T1"
                      value={suscriptionIdT1}
                      onChange={conditionView ? null : changeSuscriptionIdT1Handler}
                      readOnly={conditionView ? true : false}
                      disabled={conditionView ? true : false}
                    />
                  </Form.Group>
                </Row>
                {isLoading ? <Spinner /> : null}
                <hr></hr>

                {renewedSince ?
                  <Row className="mb-2 justify-content-end">
                    <InputText defaultValue={(dateFormat(renewedSince, "dd-mm-yyyy", true))} label={'Renewed Since'} handler={formFieldsHandler} conditionView={true} width={'3'} />
                    <InputText defaultValue={renewedBy} label={'Renewed by'} handler={formFieldsHandler} conditionView={true} width={'2'} />
                  </Row> : null}

                {addSubmitButton}
                {'  '}  {'  '}
                {setCloseButton}
              </Form>
              <br />
              {(successSend == 'danger') ? (<Alert key='danger' variant='danger'> ¡Not Update, Check Period Plan or Try later!</Alert>)
                : (successSend == 'success') ? (<Alert key='success' variant='success'> ¡Send Success!</Alert>) : ""}
            </Tab>

            <Tab eventKey="ClientIdentyti" title="Identyti">
              {t1dataShopId ? <TabClientIdentyti setCloseButton={setCloseButton} t1dataShopId={t1dataShopId} conditionView={conditionView} handleClose={handleClose} providerTypeOptions={providerTypeOptions} /> : null}
            </Tab>
          </Tabs>
        </Modal.Body>

      </Modal>
    </>
  );
}